import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { DataResponseHttp } from '../../../../http-models/data-response.http';
import { UserQueryHttp } from '../../../../http-models/systems/user/user-query.http';
import { UserHttp } from '../../../../http-models/systems/user/user.http';
import { StatusResponseHttp } from '../../../../http-models/status-response.http';
import { PutUserLastTokenHttp } from '../../../../http-models/systems/user/put-user-last-token.http';
import { PutUserDefaultHospitalHttp } from '../../../../http-models/systems/user/put-user-default-hospital.http';

@Injectable({
    providedIn: 'root',
})
export class UserHttpService {
    private readonly _httpClient = inject(HttpClient);

    getPaginated(
        params: string
    ): Observable<DataResponseHttp<UserQueryHttp>> {
        const url = `${environment.api.baseAddress}${environment.api.system.users}${params}`;
        return this._httpClient.get<DataResponseHttp<UserQueryHttp>>(url);
    }

    getById(id: number): Observable<DataResponseHttp<UserHttp>> {
        const url = `${environment.api.baseAddress}${environment.api.system.users}/${id}`;
        return this._httpClient.get<DataResponseHttp<UserHttp>>(url);
    }

    getByEmail(email: string): Observable<DataResponseHttp<UserHttp>> {
        const url = `${environment.api.baseAddress}${environment.api.system.users}/${email}`;
        return this._httpClient.get<DataResponseHttp<UserHttp>>(url);
    }

    getAuthenticated(): Observable<DataResponseHttp<UserHttp>> {
        const url = `${environment.api.baseAddress}${environment.api.system.users}/Authenticated`;
        return this._httpClient.get<DataResponseHttp<UserHttp>>(url);
    }

    getUserLastToken(): Observable<DataResponseHttp<string>> {
        const url = `${environment.api.baseAddress}${environment.api.system.users}/last-token`;
        return this._httpClient.get<DataResponseHttp<string>>(url);
    }

    post(request: FormData): Observable<DataResponseHttp<UserHttp>> {
        const url = `${environment.api.baseAddress}${environment.api.system.users}`;
        return this._httpClient.post<DataResponseHttp<UserHttp>>(
            url,
            request
        );
    }

    put(request: FormData): Observable<DataResponseHttp<UserHttp>> {
        const url = `${environment.api.baseAddress}${environment.api.system.users}`;
        return this._httpClient.put<DataResponseHttp<UserHttp>>(
            url,
            request
        );
    }

    putLastToken(request: PutUserLastTokenHttp): Observable<StatusResponseHttp> {
        const url = `${environment.api.baseAddress}${environment.api.system.users}/last-token`;
        return this._httpClient.put<StatusResponseHttp>(
            url,
            request
        );
    }

    putProfile(request: FormData): Observable<DataResponseHttp<UserHttp>> {
        const url = `${environment.api.baseAddress}${environment.api.system.users}/Profile`;
        return this._httpClient.put<DataResponseHttp<UserHttp>>(
            url,
            request
        );
    }

    delete(id: number): Observable<StatusResponseHttp> {
        const url = `${environment.api.baseAddress}${environment.api.system.users}/${id}`;
        return this._httpClient.delete<StatusResponseHttp>(url);
    }

    clearSession(email: string): Observable<StatusResponseHttp> {
        const url = `${environment.api.baseAddress}${environment.api.system.users}/${email}/clear-session`;
        return this._httpClient.get<StatusResponseHttp>(url);
    }

    putDefaultHospital(request: PutUserDefaultHospitalHttp): Observable<StatusResponseHttp> {
        const url = `${environment.api.baseAddress}${environment.api.system.users}/change-default-hospital`;
        return this._httpClient.put<StatusResponseHttp>(
            url,
            request
        );
    }

}
